





























































































































































import { diff } from "deep-object-diff";
import { EventBus } from "@/event-bus";
import MachinesModal from "@/components/MachinesModal.vue";
import { checklistPostReq } from "@/services/checklist.service";
import TranslatedItem from "@/components/TranslatedItem.vue";

export default {
  props: ["compLoaded"],
  data() {
    return {
      show: false,
      loading: false,
      filter1: null,
      the_task: null,
      the_comp: null,
      org_entry: {},
      org_machines: [],
      username: null,
      showMachines: false,
      field_name_message: [],
      sel_addmachines: [],
      sel_removemachines: [],
      sel_machinesingroup: [],
      modal_title: "exportieren",
      export_dialog: false,
      dialog1: false,
    };
  },
  components: {
    MachinesModal,
    TranslatedItem,
  },
  watch: {
    compLoaded: function (val, oldVal) {
      this.the_task = null;
    },
    entry: function (val, oldVal) {
      this.updateUsername();
    },
  },
  computed: {
    appLang: function () {
      return this.$store.state.lang
    },
    onlyPV: function () {
      return this.$store.getters.userRole.db_region //this.userRole.db_region == 'eso'
    },
    copy_entry() {
      return (
        this.$store.state.copy_entry &&
        this.$store.state.copy_entry.type == "task"
      );
    },
    copy_entry_name() {
      return this.$store.state.copy_entry && this.$store.state.copy_entry.name;
    },
    lblTasks() {
      return this.$t("TASKS") + " (" + this.tasks.length + ")";
    },
    entry() {
      if (this.$store.state.cl_component) {
        if (!this.$store.state.cl_component.machinegroup_list) {
          this.$store.state.cl_component.machinegroup_list = [];
        }

        if (this.$store.state.cl_component.machinegroup) {
          if (!this.$store.state.cl_component.machinegroup_created) {
            this.$store.state.cl_component.machinegroup_created = true;
            this.$store.state.cl_component.machinegroup_list = [
              this.$store.state.cl_component.machinegroup,
            ];
          }
        }

        this.$store.state.cl_component.machinegroup_created = true;

        return this.$store.state.cl_component;
      }
      return {};
    },
    saving() {
      return (
        this.$store.state.saving &&
        (this.$store.state.saving_type == "subcomponent" ||
          this.$store.state.saving_type == "component")
      );
    },
    hasChanges() {
      if (!this.org_entry || !this.entry || !this.org_entry._id) return false;
      let a = { ...this.org_entry }; let b = { ...this.entry };
      delete a.created_at; delete b.created_at;
      delete a.user_uid; delete b.user_uid;
      return JSON.stringify(a) !== JSON.stringify(b);
    },
    tasks() {
      return this.$store.state.cl_task_list;
    },
    insp_types() {
      return this.$store.state.inspection_types;
    },
    projects() {
      return this.$store.state.projects;
    },
    machinegroups() {
      return this.$store.state.cl_machine_groups;
    },
    machines() {
      if (this.filter1 && this.filter1.length > 0) {
        return this.$store.state.machines.filter((machine) => {
          return (
            machine.text.toLowerCase().indexOf(this.filter1.toLowerCase()) !==
            -1
          );
        });
      }
      return this.$store.state.machines;
    },
  },
  mounted() {
    EventBus.$on("comp_changed", this.comChangedHandler);
    EventBus.$on("task_closed", this.taskClosedHandler);
    EventBus.$on("entry_added", this.addedHandler);
    EventBus.$on("updateInformElement", this.updateInformElement);
    this.updateUsername();
  },
  destroyed() {
    EventBus.$off("comp_changed", this.comChangedHandler);
    EventBus.$off("task_closed", this.taskClosedHandler);
    EventBus.$off("entry_added", this.addedHandler);
    EventBus.$off("updateInformElement", this.updateInformElement);
  },
  methods: {
    updateInformElement: function (d) {
      /*
      if (d.type != "question" && d.uid != this.entry.uid) {
        console.log("QUESTION speichern")
        this.save()
      }
      */
      this.save();
    },
    updateUsername: function () {
      if (this.entry.user_uid) {
        this.username = this.$store.state.users[this.entry.user_uid];
      } else {
        this.username = "";
      }
    },
    selTask: function () {
      this.$emit("selectTask", this.the_task);
    },

    save() {
      // TODO: auslagern
      let check1 = { ...this.org_entry };
      let check2 = { ...this.entry };
      delete check1.created_at;
      delete check2.created_at;
      delete check1.user_uid;
      delete check2.user_uid;
      delete check1.type;
      delete check2.type;

      if (
        JSON.stringify(check1) != JSON.stringify(check2) ||
        this.entry.machines.length != this.org_machines.length
      ) {
        if (this.entry.level > 1) {
          this.entry.type = "subcomponent";
        } else {
          this.entry.type = "component";
        }
        this.entry.user_uid = this.$store.state.userId;
        this.entry.created_at = Date.now();
        this.updateUsername();
        this.org_entry = { ...this.entry };
        this.$emit("updateAct", this.entry);
      } else {
        this.$emit("updateAct", { no_changes: true });
      }
    },
    createAct: function (type) {
      this.$emit("createAct", { type: type });
    },
    sortAct: function (type) {
      this.$emit("sortAct", { type: type, level: this.entry.level });
    },
    copyAct: function (type) {
      this.entry.type = type;
      this.$emit("copyAct", {
        type: type,
        cl_uid: this.entry.cl_uid,
        uid: this.entry.uid,
        level: this.entry.level,
        name: this.entry.name,
      });
    },
    deleteAct: function (type) {
      if (this.entry.level > 1) {
        this.entry.type = "subcomponent";
      } else {
        this.entry.type = "component";
      }
      this.$emit("deleteAct", this.entry);
    },
    close: function () {
      EventBus.$emit("component_closed", this.entry);
    },
    pasteEntry: function () {
      this.$emit("pasteAct");
    },
    addedHandler: function (data) {
      if (data.type == "task") {
        this.the_task = data.entry_uid;
        this.selTask();
      }
    },
    taskClosedHandler: function (data) {
      this.the_task = null;
    },
    comChangedHandler: function (d) {
      let showCmp = false;

      if (
        this.$store.state.initParams["comp" + (parseInt(d.level) + 1)] &&
        this.$store.state.initParams["comp" + (parseInt(d.level) + 1)].length >
        2
      ) {
        console.log("Erst Komponente auf anderer Ebene wählen");
      }
      // Deeplink auf die Aufgabe, wenn es nicht noch eine Unterkomponente gibt, die aktiviert werden muss
      else if (
        this.$store.state.initParams.task &&
        this.$store.state.initParams.task.length > 2 &&
        this.tasks.filter(
          (item) => item.value == this.$store.state.initParams.task
        ).length > 0
      ) {
        this.$emit("selectTask", this.$store.state.initParams.task);
        this.$store.state.initParams.task = "t";
        this.showCmp = true;
      }
      // Aufgabe wählen, wenn es nur eine gibt
      else if (this.tasks.length == 1) {
        this.$emit("selectTask", this.tasks[0].value);
        this.showCmp = true;
      }

      if (showCmp) {
        this.org_entry = { ...this.entry };
        this.org_machines = JSON.parse(JSON.stringify(this.entry.machines));
        this.updateUsername();
      }
    },
    dialogClosed: function (val) {
      this.showMachines = false;
    },
    changeMachines: function (val) {
      this.showMachines = false;
      // {add_machines: this.add_machines, remove_machines: this.remove_machines}
      this.entry.machines = val.add_machines;
      this.entry.remove_machines = val.remove_machines;

      if (val.group_uid) {
        // Es wurde eine neue Gruppe aus der Auswahl erstellt
        this.entry.machinegroup_list = [val.group_uid];
      }
    },
    openMachinesDialog: function () {
      this.sel_addmachines = JSON.parse(JSON.stringify(this.entry.machines));
      this.sel_removemachines = JSON.parse(
        JSON.stringify(this.entry.remove_machines)
      );
      this.showMachines = true;

      this.sel_machinesingroup = [];

      if (this.machinegroups) {
        for (let k of this.machinegroups) {
          if (this.entry.machinegroup_list) {
            for (let m of this.entry.machinegroup_list) {
              if (k.value == m) {
                this.sel_machinesingroup = this.sel_machinesingroup.concat(
                  JSON.parse(JSON.stringify(k.machines))
                );
              }
            }
          } else {
            if (k.value == this.entry.machinegroup) {
              this.sel_machinesingroup = JSON.parse(JSON.stringify(k.machines));
              break;
            }
          }
        }
      }
    },
    exportCsv(item) {
      this.modal_title = this.$t('CSV_EXPORT') + "...";
      this.export_dialog = true;

      checklistPostReq("export-csv", item).then((resp) => {
        //console.log(resp.item)
        this.export_dialog = false;

        var csvData = new Blob(["\uFEFF" + resp.item.csv], {
          type: "text/csv;charset=windows-1252",
        });
        var csvURL = null;
        if (navigator.msSaveBlob) {
          csvURL = navigator.msSaveBlob(csvData, "download.csv");
        } else {
          csvURL = window.URL.createObjectURL(csvData);
        }
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute(
          "download",
          new Date().getFullYear() +
          "_" +
          (new Date().getMonth() + 1) +
          "_" +
          new Date().getDate() +
          "_checkliste.csv"
        );
        tempLink.click();

        /*
          if (resp.status == "success") {
            window.open(`${this.$apiBase}/importjson/download-csv/${resp.item.cl_uid}/${resp.item.file_uid}`)
          }
          */
      });

      //   checklistPostReq('export-json', item)
    },
  },
};
